module.exports = __webpack_public_path__ + "img/credinord@2x.fff42dd.png";